import { ConfirmacaoModalModule } from './../confirmacao-modal/confirmacao-modal..module';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';

import { StarterViewComponent } from './starterview.component';

import { ToastrModule } from 'ngx-toastr';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi, withJsonpSupport } from '@angular/common/http';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { AppSharedModule } from 'app/app-shared.module';
import { GerenciamentoDeTalhoesModule } from './my-fields/gerenciamento-de-talhoes/gerenciamento-de-talhoes.module';
import { TranslateModule } from '@ngx-translate/core';
import { UploadFieldFilesComponent } from 'app/modules/appviews/my-fields/visualizar-talhoes/upload-field-files/upload-field-files.component';
import { SendFieldFilesComponent } from './my-fields/visualizar-talhoes/send-field-files/send-field-files.component';
import { FormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { SidebarMenuFieldFilesComponent } from './my-fields/visualizar-talhoes/sidebar-menu-field-files/sidebar-menu-field-files.component';
import { DeviceService } from 'app/core/services/device.service';
@NgModule({ declarations: [
        StarterViewComponent,
        UploadFieldFilesComponent,
        SendFieldFilesComponent,
        SidebarMenuFieldFilesComponent,
    ],
    exports: [
        StarterViewComponent,
        UploadFieldFilesComponent,
        SendFieldFilesComponent,
        SidebarMenuFieldFilesComponent,
    ], imports: [BrowserModule,
        CommonModule,
        RouterModule,
        ToastrModule.forRoot(),
        GoogleMapsModule,
        MatAutocompleteModule,
        AppSharedModule,
        GerenciamentoDeTalhoesModule,
        ConfirmacaoModalModule,
        TranslateModule,
        FormsModule,
        MatSlideToggleModule], providers: [provideHttpClient(withInterceptorsFromDi(), withJsonpSupport()), DeviceService] })
export class AppviewsModule {}
